// fallback copy used when the highlighted carrier has no Empty_Highlight_Message set in Zoho
export const DEFAULT_EMPTY_HIGHLIGHT_MESSAGE =
  'None of your agents are missing critical appointments';
